var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_651_930)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.58214 0 0 3.58214 0 8C0 12.4179 3.58214 16 8 16C12.4179 16 16 12.4179 16 8C16 3.58214 12.4179 0 8 0ZM8 14.6429C4.33214 14.6429 1.35714 11.6679 1.35714 8C1.35714 4.33214 4.33214 1.35714 8 1.35714C11.6679 1.35714 14.6429 4.33214 14.6429 8C14.6429 11.6679 11.6679 14.6429 8 14.6429Z",
    fill: "#4A4A4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.14258 4.85714C7.14258 5.08447 7.23288 5.30249 7.39363 5.46324C7.55438 5.62398 7.77239 5.71429 7.99972 5.71429C8.22705 5.71429 8.44507 5.62398 8.60581 5.46324C8.76656 5.30249 8.85686 5.08447 8.85686 4.85714C8.85686 4.62982 8.76656 4.4118 8.60581 4.25105C8.44507 4.09031 8.22705 4 7.99972 4C7.77239 4 7.55438 4.09031 7.39363 4.25105C7.23288 4.4118 7.14258 4.62982 7.14258 4.85714ZM8.42829 6.85714H7.57115C7.49258 6.85714 7.42829 6.92143 7.42829 7V11.8571C7.42829 11.9357 7.49258 12 7.57115 12H8.42829C8.50687 12 8.57115 11.9357 8.57115 11.8571V7C8.57115 6.92143 8.50687 6.85714 8.42829 6.85714Z",
    fill: "#4A4A4A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_651_930"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoCircle);
export default __webpack_public_path__ + "static/media/infoCircle.d0d9693b729f726e6b7956eeecae7547.svg";
export { ForwardRef as ReactComponent };